import { EyeOutlined } from '@ant-design/icons';
import { getGetBackDocumentaleFascicoliIdDocumentiIdDownloadQueryOptions } from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import {
  useAuthDownload,
  useHasDocumentsInlineViewer,
} from '@framework/common-web';
import { Button, message } from 'antd';
import React from 'react';

export interface IDocumentalDownloadButtonProps {
  token: string | null | undefined;
  dossierId: string | null | undefined;
  documentId: string | null | undefined;
  filename: string;
}

/**
 * Pulsante "Scarica" per il download dei documenti nel fasicolo dal documentale.
 * (Tab "Fascicolo" del procedimento)
 */
export function DocumentalDownloadButton(
  props: IDocumentalDownloadButtonProps,
) {
  const { token, documentId, dossierId, filename } = props;
  const hasInlineViewer = useHasDocumentsInlineViewer();

  const { download, isFetching } = useAuthDownload(
    getGetBackDocumentaleFascicoliIdDocumentiIdDownloadQueryOptions,
    [dossierId ?? '', documentId ?? '<N/A>'],
    {
      filename,
      onError: (e: any) => {
        message.error(getNetworkErrorMessage(e, 'Si è verificato un problema durante l\'apertura del file')); // prettier-ignore
      },
      // Imposto il token di autorizzazione per il download
      headers: { 'Authorization-Documenti': token ?? '<N/A>' },
      openInNewWindow: true,
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      icon={<EyeOutlined />}
      type="link"
      loading={isFetching}
      onClick={() => {
        if (!token || !dossierId || !documentId) {
          console.error('Impossibile scaricare il documento. Token o ID non disponibili.', { props }); // prettier-ignore
          message.error('Impossibile scaricare il documento. Token o ID non disponibili.'); // prettier-ignore
          return;
        }

        download();
      }}
    >
      Visualizza
    </Button>
  );
}
